// extracted by mini-css-extract-plugin
module.exports = {"inbox":"Inbox_inbox__3gx5E","main":"Inbox_main__4UmFt","error":"Inbox_error__1Zip5","errorH1":"Inbox_errorH1__1aK0d"};